module.exports = __webpack_public_path__ + "media/notification.d8653ed1.wav";